import React from "react";
import EventPage from "..";

// NTT DATA campaign page: the public event page with their logo; purchases carry the campaign tag
const EventsNTTDATA = () => <EventPage variant="ntt" />;

export default EventsNTTDATA;
